const View = require('public_framework/view')
const $ = require('jquery')
const Flatpickr = require('flatpickr')

const ALLOWED_DATEPICKER_OPTS = ['mode', 'inline', 'dateFormat']

function extractOptions (datepickerEl) {
  const options = {}
  ALLOWED_DATEPICKER_OPTS.forEach(key => {
    const attrValue = datepickerEl.getAttribute(`data-${key}`)
    if (attrValue) {
      options[key] = attrValue
    }
  })

  return options
}

module.exports = class DatepickerView extends View {
  constructor () {
    super(...arguments)
    this.datefield = this.el.querySelector('.js-datefield')

    // Get custom Flatpickr from attributes
    const options = extractOptions(this.datefield)

    this.flatpickr = new Flatpickr(this.datefield, {
      ...options,
      onOpen: () => this.subscribe(),
      onClose: () => {
        this.unsubscribe()
        this.datefield.blur()
      }
    })

    $(this.datefield).on('change', (e) => {
      // Hack for iOS safari which does show placeholders for date input
      this.$('.flatpickr-mobile').toggleClass('has-value', !!e.target.value)
    })

    this.listen('datepicker:clear', this.clear.bind(this))
  }

  subscribe () {
    $(document).on('keyup.datepicker', e => {
      if (e.key !== 'Backspace') return
      this.flatpickr.clear()
      this.flatpickr.close()
    })
  }

  unsubscribe () {
    $(document).off('keyup.datepicker')
  }

  clear () {
    this.flatpickr.clear()
  }

  onUnload () {
    this.unsubscribe()
    this.flatpickr.destroy()
  }
}



// WEBPACK FOOTER //
// ./front/apps/public/shared/components/ui/datepicker/views/datepicker.js